import { Form, Radio } from 'antd';
import { Rule } from 'antd/es/form';
import { OptionEntity } from 'domain/entities/OptionEntity';
import React, { useEffect } from 'react';
import getMessage from 'utilities/constants/MESSAGE';

export interface RadioProps extends React.InputHTMLAttributes<HTMLInputElement> {
    options: OptionEntity[];
    name?: string;
    disabled?: any;
    required?: boolean;
    requiredMessage?: string;
    callback?: any;
    rules?: Rule[];
    label?: string;
    labelClassName?: string;
    onChange?: (value: any) => void;
}

export const FormRadio = ({
    disabled,
    options,
    style,
    rules = [],
    label,
    required,
    requiredMessage,
    labelClassName = '',
    name,
    ...props
}: RadioProps) => {
    const [displayRequired, setDisplayRequired] = React.useState<boolean>(false);

    useEffect(() => {
        setDisplayRequired(required ?? false);
    }, [required]);

    return (
        <>
            <span className={labelClassName}>
                {label}
                {label && displayRequired ? <span style={{ color: '#EB5757' }}>*</span> : <></>}
            </span>
            <Form.Item
                required={displayRequired}
                className={props.className}
                name={name}
                label={false}
                initialValue={props.defaultValue}
                rules={rules.concat([
                    {
                        required: required ? true : false,
                        message: requiredMessage ?? getMessage('In_Required', label),
                    },
                ])}
            >
                <Radio.Group
                    onChange={(e) => {
                        props.onChange && props.onChange(e.target.value);
                    }}
                    disabled={disabled}
                    style={{ ...style }}
                >
                    {options?.map((element) => {
                        return (
                            <Radio
                                key={element.value}
                                style={{ marginRight: 16 }}
                                value={element.value}
                            >
                                {element.label}
                            </Radio>
                        );
                    })}
                </Radio.Group>
            </Form.Item>
        </>
    );
};
